import { Button } from "@tblabs/truffle";
import { Svg } from "./Svg";


export class XButton extends Button
{
    constructor(type: string, text: string, icon: string, onClick?: (btn: Button) => void)
    {
        super(text, onClick);

        this.Prepend(new Svg(icon).Class("button__icon"));
        this.Class("xbutton xbutton--" + (type || "light"));
    }
}
